module.exports = __webpack_public_path__ + "img/icon-picture.89eb0c3a.png";